import { createConsumer } from "@anycable/web";

import { createHandoffMessageHandler } from "./messageHandler";

type AnyCableConsumer = ReturnType<typeof createConsumer>;
type AnyCableSubscription = ReturnType<AnyCableConsumer["subscriptions"]["create"]>;

const state = {
  consumer: null as AnyCableConsumer | null,
  subscription: null as AnyCableSubscription | null,
  handoffHandled: false,
};

const getOrCreateConsumer = (): AnyCableConsumer => {
  if (!state.consumer) {
    state.consumer = createConsumer();
  }

  return state.consumer;
};

const handleMessage = createHandoffMessageHandler({
  isHandoffHandled: () => state.handoffHandled,
  markHandoffHandled: () => {
    state.handoffHandled = true;
  },
  updateIntercomUser: intercomUser => {
    if (typeof window.updateIntercomUser === "function") {
      window.updateIntercomUser(intercomUser);
    }
  },
  performAdaToIntercomHandoff: () => {
    if (typeof window.performAdaToIntercomHandoff === "function") {
      window.performAdaToIntercomHandoff();
    }
  },
});

const startAdaHandoffCable = (): void => {
  if (state.subscription) {
    return;
  }

  const consumer = getOrCreateConsumer();

  state.subscription = consumer.subscriptions.create(
    { channel: "Ada::HandoffChannel" },
    {
      received: handleMessage,
    }
  );
};

// Unsubscribing ensures the next subscribe triggers a fresh `subscribed` callback
// on the server, which sends a new Intercom JWT.
const stopAdaHandoffCable = (): void => {
  if (state.subscription) {
    try {
      state.subscription.unsubscribe();
    } catch {
      // Unsubscribe may fail if already disconnected
    }
    state.subscription = null;
  }

  state.handoffHandled = false;
};

export { startAdaHandoffCable, stopAdaHandoffCable };
